module.exports = __webpack_public_path__ + "media/images/design/common/images/icon_youtube-3628027ee120f07a6191fbd824d5b5fe.jpg";